import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import QuizIcon from "@mui/icons-material/Quiz";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import pagePath from "../../../util/constants/pagePath";
import "./sidebar.css";

const Sidebar = () => {
    const location = useLocation();
    const navItems = [
        {
            name: "Dashboard",
            caption: "Progress overview",
            path: pagePath.dashboard,
            icon: <DashboardCustomizeIcon />
        },
        {
            name: "Practice",
            caption: "Tests and domains",
            path: pagePath.practice,
            icon: <QuizIcon />
        },
        {
            name: "Account",
            caption: "Plan and billing",
            path: pagePath.account,
            icon: <ManageAccountsIcon />
        },
        {
            name: "Support",
            caption: "Help and contact",
            path: pagePath.support,
            icon: <ContactSupportIcon />
        }
    ];

    const isActive = (path) => {
        if (path === pagePath.practice) {
            return location.pathname === pagePath.practice || location.pathname.startsWith(pagePath.practice + "/");
        }
        return location.pathname === path;
    };

    return (
        <aside className="layout-sidebar">
            <nav className="layout-sidebar-nav" aria-label="Primary">
                {navItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`layout-sidebar-nav-item ${isActive(item.path) ? "layout-sidebar-nav-item-active" : ""}`}
                    >
                        <span className="layout-sidebar-nav-icon">{item.icon}</span>
                        <span>
                            <strong>{item.name}</strong>
                            <small>{item.caption}</small>
                        </span>
                    </Link>
                ))}
            </nav>
        </aside>
    )
}

export default Sidebar;
